import { Injectable } from '@angular/core';
import { IChangeUserRequest, IJoinClassroomRequest } from '@models/user';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { IStudentClassroomDTO } from '@app/infrastructure/models/classroom';
import { IStudentClassListItemDTO } from '@app/infrastructure/models/student-classroom';
import { IStudentGradeUnitListItemDTO } from '@app/infrastructure/models/grade-unit/student-grade-unit';
import { IStudentGradeUnitDayListItemDTO } from '@app/infrastructure/models/grade-unit/student-grade-unit-day';
import { IPagedResults } from '@app/infrastructure/models/response';

@Injectable({
  providedIn: 'root',
})
export class StudentClassroomService {
  private controllerRoute: string = 'students';
  private url: string = `${environment.apiRoute}/${this.controllerRoute}`;

  constructor(private apiService: ApiService) {}

  public getClassroomList(
    studentId: string,
  ): Observable<IStudentClassListItemDTO[]> {
    const endpoint = `${this.url}/${studentId}/classrooms`;

    return this.apiService.get<IStudentClassListItemDTO[]>(endpoint);
  }

  public getAllAssignedUnits(
    studentId: string,
    classroomId: string,
  ): Observable<IPagedResults<IStudentGradeUnitListItemDTO>> {
    const endpoint = `${this.url}/${studentId}/${classroomId}/units`;

    return this.apiService.get<IPagedResults<IStudentGradeUnitListItemDTO>>(
      endpoint,
    );
  }
  // TODO: move to a separate service
  public getAllAssignedUnitDays(
    studentId: string,
    unitNumber: number,
    gradeLevel: string,
    classroomId: string,
    options = {},
  ): Observable<IPagedResults<IStudentGradeUnitDayListItemDTO>> {
    const endpoint = `${this.url}/${studentId}/${classroomId}/assignments/grades/${gradeLevel}/units/${unitNumber}/days`;

    return this.apiService.get<IPagedResults<IStudentGradeUnitDayListItemDTO>>(
      endpoint,
      options,
    );
  }

  public checkClassroomCode(
    changeUserRequest: IChangeUserRequest,
  ): Observable<IStudentClassroomDTO> {
    const endpoint = `${environment.apiRoute}/invites/${changeUserRequest.inviteCode}/classrooms`;
    return this.apiService.get<IStudentClassroomDTO>(endpoint);
  }

  public joinClassroom(
    studentId: string,
    changeUserRequest: IChangeUserRequest,
  ): Observable<IStudentClassroomDTO> {
    const endpoint = `${this.url}/${studentId}/classrooms`;
    return this.apiService.post<IStudentClassroomDTO, IJoinClassroomRequest>(
      endpoint,
      {
        inviteCode: changeUserRequest.inviteCode,
      },
    );
  }
}
